import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Chip } from "@mui/material";
import CustomDataGrid from "../../Components/CustomDataGrid";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import { toast } from "react-toastify";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useLang } from "../../context/LanguageContext";

const ItemsBelowMinQuantity = () => {
    const [items, setItems] = useState([]);
    const authHeader = useAuthHeader();
    const { t } = useLang();

    const fetchItems = async () => {
        try {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/items/below-min-quantity`,
                {
                    method: "GET",
                    headers: {
                        Authorization: authHeader, // Added Authorization header
                        "Content-Type": "application/json",
                    },
                },
            );
            if (response.ok) {
                const responseData = await response.json();
                setItems(responseData.items);
            } else {
                throw new Error(
                    "Failed to fetch items below minimum quantity.",
                );
            }
        } catch (error) {
            toast.error(error.message || "Error fetching items.");
        }
    };

    useEffect(() => {
        fetchItems();
    }, [authHeader]);

    const columns = [
        { field: "name", headerName: "Name", width: 200 },
        { field: "barcode", headerName: "Barcode", width: 150 },
        { field: "description", headerName: "Description", width: 250 },
        { field: "minAlarmQuantity", headerName: "Min Quantity", width: 150 },
        {
            field: "quantityRemaining",
            headerName: "Quantity Remaining",
            width: 150,
        },
    ];

    return (
        <Box sx={{ width: "100%" }}>
            {/* Modern Page Header */}
            <Paper
                elevation={0}
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    p: 2.5,
                    borderRadius: 3,
                    background:
                        "linear-gradient(135deg, #ff8f00 0%, #e65100 100%)",
                    color: "white",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <WarningAmberIcon sx={{ fontSize: 32, opacity: 0.9 }} />
                    <Box>
                        <Typography variant="h5" fontWeight={700}>
                            {t("ITEMS_BELOW_MIN")}
                        </Typography>
                        <Chip
                            label={`${items.length} ${t("ITEMS")}`}
                            size="small"
                            sx={{
                                bgcolor: "rgba(255,255,255,0.2)",
                                color: "white",
                                fontWeight: 600,
                                mt: 0.5,
                            }}
                        />
                    </Box>
                </Box>
            </Paper>
            <CustomDataGrid columns={columns} rows={items} perPage={20} />
        </Box>
    );
};

export default ItemsBelowMinQuantity;
